var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
const defaultReducerState = {
  flight_control: getDefaultAsyncWrapperObj(),
  groups: getDefaultAsyncWrapperObj(),
  isolation_groups: getDefaultAsyncWrapperObj(),
  flight_configurations: getDefaultAsyncWrapperObj(),
  flights_dictionary: getDefaultAsyncWrapperObj()
};
const prefix = "FLIGHT_CREATE";
const createLoaderActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD`,
  LOADING: `${prefix}/${resource}/LOADING`,
  LOADED: `${prefix}/${resource}/LOADED`
});
const managementGroupsActionTypes = createLoaderActionTypes("MANAGEMENT_GROUPS");
const flightControlActionTypes = createLoaderActionTypes("FLIGHT_CONTROL");
const validateFlightsActionTypes = createLoaderActionTypes("VALIDATE_FLIGHTS");
const createFlightActionTypes = createLoaderActionTypes("CREATE_FLIGHTS");
const loadManagementGroups = (workspaceId, managementGroup) => {
  return {
    type: managementGroupsActionTypes.LOAD,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadingManagementGroups = () => {
  return {
    type: managementGroupsActionTypes.LOADING,
    payload: {
      groups: {
        data: null,
        status: AsyncRequestStatus.Pending
      }
    }
  };
};
const loadedManagementGroups = (groups) => {
  return {
    type: managementGroupsActionTypes.LOADED,
    payload: {
      groups
    }
  };
};
const loadFlightControl = (workspaceId, managementGroup) => {
  return {
    type: flightControlActionTypes.LOAD,
    payload: {
      managementGroup,
      workspaceId
    }
  };
};
const loadingFlightControl = (payload) => {
  return {
    type: flightControlActionTypes.LOADING,
    payload: {
      flight_control: {
        data: null,
        status: AsyncRequestStatus.Pending
      }
    }
  };
};
const loadedFlightControl = (payload) => {
  return {
    type: flightControlActionTypes.LOADED,
    payload: {
      flight_control: payload
    }
  };
};
const validateFlights = (payload) => {
  return {
    type: validateFlightsActionTypes.LOAD,
    payload
  };
};
const validatingFlights = (payload) => {
  return {
    type: validateFlightsActionTypes.LOADING,
    payload: {
      flights_dictionary: {
        data: null,
        status: AsyncRequestStatus.Pending
      }
    }
  };
};
const validatedFlights = (payload) => {
  return {
    type: validateFlightsActionTypes.LOADED,
    payload: {
      flights_dictionary: payload
    }
  };
};
const createFlights = (payload) => {
  return {
    type: createFlightActionTypes.LOAD,
    payload
  };
};
const creatingFlights = (payload) => {
  return {
    type: createFlightActionTypes.LOADING,
    payload: {
      flight_configurations: {
        data: null,
        status: AsyncRequestStatus.Pending
      }
    }
  };
};
const flightsCreated = (payload) => {
  return {
    type: createFlightActionTypes.LOADED,
    payload: {
      flight_configurations: payload
    }
  };
};
const reducer = (state = defaultReducerState, action) => {
  switch (action.type) {
    case managementGroupsActionTypes.LOADING:
    case managementGroupsActionTypes.LOADED:
    case flightControlActionTypes.LOADING:
    case flightControlActionTypes.LOADED:
    case createFlightActionTypes.LOADING:
    case createFlightActionTypes.LOADED:
    case validateFlightsActionTypes.LOADING:
    case validateFlightsActionTypes.LOADED:
      return __spreadValues(__spreadValues({}, state), action.payload);
    default:
      return state;
  }
};
export {
  createFlightActionTypes,
  createFlights,
  createLoaderActionTypes,
  creatingFlights,
  reducer as default,
  defaultReducerState,
  flightControlActionTypes,
  flightsCreated,
  loadFlightControl,
  loadManagementGroups,
  loadedFlightControl,
  loadedManagementGroups,
  loadingFlightControl,
  loadingManagementGroups,
  managementGroupsActionTypes,
  reducer,
  validateFlights,
  validateFlightsActionTypes,
  validatedFlights,
  validatingFlights
};
//# sourceMappingURL=CreateContainer.ducks.js.map
